import { useMediaQuery, useTheme } from "@mui/material";
import {
  useIsIndividualContributor,
  useStartNewChat,
} from "../../../../modules/common";
import {
  MediumCustomIcon,
  SmallCustomIcon,
} from "../../../../modules/components/layer00";
import {
  MobileNavBar,
  NavBar,
  RecentChatsNav,
} from "../../../../modules/components/layer02";
import { NavBarItemProps } from "../../layer01/NavBarItem/NavBarItem";
import { useAppSelector } from "utils/redux/hooks";
import { selectGenerateInstructionsStatus } from "app/containers/Chatbot/slice";
import SiteLoadingPageWithOverlay from "app/storybookComponents/Loading/SiteLoadingPageWithOverlay";

const priorityItems: {
  label: string;
  items: NavBarItemProps[];
} = {
  label: "Priorities",
  items: [
    {
      icon: <MediumCustomIcon icon="ACCOUNT" />,
      label: "Your Team",
      path: "/user/team",
    },
  ],
};

export const UserNavBar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // undefined while loading, so we show the loading overlay instead of flashing the IC nav at managers.
  const isIndividualContributor = useIsIndividualContributor();

  const overviewItems: {
    label: string;
    items: NavBarItemProps[];
  } = {
    label: "OverView",
    items: [
      {
        icon: <MediumCustomIcon icon="PROCESSOR" />,
        label: "Bo zone",
        path: "/user/boZone",
      },
      ...(isIndividualContributor
        ? []
        : [
            {
              icon: <MediumCustomIcon icon="DASHBOARD" />,
              label: "Dashboard",
              path: "/user/dashboard",
            },
          ]),
    ],
  };

  // Chat with Bo and Check In share the same underlying chat thread, so
  // navigating between them while a thread is still being generated for the
  // screen being left can let that request's response land on the wrong
  // screen. Disabling nav during that window avoids the race entirely.
  const generateInstructionsStatus = useAppSelector(
    selectGenerateInstructionsStatus
  );
  const isSwitchingThread = generateInstructionsStatus === "loading";

  const chatItems: {
    label: string;
    items: NavBarItemProps[];
  } = {
    label: "Chat",
    items: [
      {
        icon: <MediumCustomIcon icon="FLAG" />,
        label: "Check in",
        path: "/user/checkIn",
        disabled: isSwitchingThread,
      },
      {
        icon: <MediumCustomIcon icon="CHAT" />,
        label: "Chat with Bo",
        path: "/user/chatWithBo",
        disabled: isSwitchingThread,
      },
    ],
  };

  const handleNewChat = useStartNewChat();

  const navProps = {
    navGroups: isIndividualContributor
      ? [overviewItems, chatItems]
      : [overviewItems, priorityItems, chatItems],
    extraSection: <RecentChatsNav />,
    bottomBottom: {
      icon: (
        <SmallCustomIcon
          icon="MESSAGE"
          stroke={theme.palette.primary.contrastText}
        />
      ),
      label: "New chat",
      onClick: handleNewChat,
      loading: isSwitchingThread,
    },
  };

  if (isIndividualContributor === undefined) {
    return <SiteLoadingPageWithOverlay />;
  }

  return isMobile ? <MobileNavBar {...navProps} /> : <NavBar {...navProps} />;
};
